import * as types from '../types';

export const selectLocation = (data) => {
    return { type: types.SELECT_LOCATION, ...data };
};

export const setLocation = (data) => {
    return { type: types.SELECT_LOCATION, data };
};
